import React, { useEffect, useRef } from 'react';
import { BannerContainerProps } from '@/types/banner';
import { useBanner } from '@/lib/banner';
import Banner from './Banner';
import BannerPopup from './BannerPopup';

const BannerContainer: React.FC<BannerContainerProps> = ({
  pusher,
  episodeId,
  userId,
  fullScreen,
  testMode = false,
}) => {
  const hasLoggedMissingPropsRef = useRef(false);
  const {
    banners,
    handleUserCloseBanner,
    handleUserClickBanner,
    errors,
    popupData,
    closePopup,
    handleCopy,
  } = useBanner(pusher, episodeId, userId, fullScreen, testMode);

  useEffect(() => {
    if (!pusher || !episodeId) {
      if (!hasLoggedMissingPropsRef.current) {
        console.log('[BANNER-CONTAINER] Missing required props, not rendering');
        hasLoggedMissingPropsRef.current = true;
      }
    } else {
      hasLoggedMissingPropsRef.current = false;
    }
  }, [pusher, episodeId]);

  // プレイヤーが存在しない場合は何も表示しない
  if (!pusher || !episodeId) {
    return null;
  }

  // バナーが存在しない場合は何も表示しない
  if (banners.length === 0) {
    return null;
  }
  
  return (
    <div
      className="tw-absolute tw-inset-0 tw-pointer-events-none"
      style={{
        // プレイヤーの実際のサイズに合わせる  
        width: '100%',
        height: '100%',
        // z-indexを下げて他の要素をブロックしないようにする
        zIndex: 200, // Headerのz-[30]より低く設定
        pointerEvents: 'none', // コンテナ自体はクリック無効
      }}
    >
      {banners.map((banner) => {
        return (
          <Banner
            key={banner.id}
            data={banner}
            position={banner.position}
            fullScreen={fullScreen}
            onClose={handleUserCloseBanner}
            onClick={handleUserClickBanner}
          />
        );
      })}
      
      {/* ポップアップ */}
      <BannerPopup
        isOpen={!!popupData}
        onClose={closePopup}
        data={popupData}
        onCopy={handleCopy}
        fullScreen={fullScreen}
      />
    </div>
  );
};

export default BannerContainer; 